'use client';

import * as DS from '@aurorasolar/ds';

import { LocationSubmit } from '@/app/components';

type Props = {
  zip: string;
};

export const QuoteCta = ({ zip }: Props) => (
  <DS.Flex bg="uiBgAlternate" w="100%">
    <DS.Flex
      alignItems={{ md: 'center' }}
      flexDirection={{ _: 'column', md: 'row' }}
      gap={6}
      justifyContent="space-between"
      maxW={DS.BorealisTheme.screens.xl}
      mx="auto"
      px={{ _: 6, lg: 10 }}
      py={{ _: 8, lg: 10 }}
      textAlign="left"
      w="100%"
    >
      <DS.Flex flex={1} gap={2} minW={0}>
        {/* Sized like the page h1 but kept as h2 so the document has a single h1 */}
        <DS.Text as="h2" text="h1">
          Ready for real numbers?
        </DS.Text>
        <DS.Text color="uiHelperCopy" text="body16">
          This is a simulation. Get real estimates for your home from trusted installers near you — free, with no
          obligation.
        </DS.Text>
      </DS.Flex>
      {/* key remounts the uncontrolled location input when the calculator ZIP changes */}
      <DS.Flex flexShrink={0} w={{ _: '100%', md: '420px' }}>
        <LocationSubmit key={zip} variant="cta" zipDefaultValue={zip}>
          Get estimates
        </LocationSubmit>
      </DS.Flex>
    </DS.Flex>
  </DS.Flex>
);
